import portalSummarySaga from './sagas'
import slice from './reducer'

export const {
  fetchRequest: portalSummaryRequest,
  fetchSuccess: portalSummarySuccess,
  fetchError: portalSummaryError,
} = slice.actions

export default slice.reducer
export { portalSummarySaga }
